/**
 * Receiver validation — mirrors the backend `PartySchema` in
 * apps/service-mail/src/modules/draft/draft.dto.ts. Receivers are not
 * required to be UPMP customers; this schema accepts free-form data.
 */
import { z } from 'zod';

export const ReceiverSchema = z.object({
  name: z.string().min(1, 'Receiver name is required').max(200),
  phone: z.string().min(1, 'Receiver phone is required').max(40),
  email: z.string().email('Invalid email').max(254).optional().or(z.literal('').transform(() => undefined)),
  addressLine1: z.string().min(1, 'Address line 1 is required').max(200),
  addressLine2: z.string().max(200).optional().or(z.literal('').transform(() => undefined)),
  city: z.string().min(1, 'City is required').max(80),
  state: z.string().min(1, 'State is required').max(80),
  postalCode: z.string().max(20).optional().or(z.literal('').transform(() => undefined)),
  countryCode: z.string().length(2, 'Country code must be 2 letters').default('NG'),
});

export type ReceiverValidated = z.infer<typeof ReceiverSchema>;
